import React, { useState, useEffect } from "react";
import { getProducts } from "../../services/productService";
import { addRepairParts } from "../../services/api";
import { AiOutlineClose, AiOutlineTool, AiOutlinePlus } from "react-icons/ai";
import styles from "../../styles/Repairs.module.css";

const UpdatePartsModal = ({ repairId, onClose, onPartsUpdated }) => {
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState("");
    const [quantity, setQuantity] = useState(1);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchProducts();
    }, []);

    const fetchProducts = async () => {
        try {
            setIsLoading(true);
            const data = await getProducts();
            setProducts(data);
            setIsLoading(false);
        } catch (error) {
            console.error("Failed to fetch products:", error);
            setIsLoading(false);
        }
    };

    const handleUpdateParts = async () => {
        if (!selectedProduct) {
            alert("Please select a product.");
            return;
        }

        const selectedProductDetails = products.find((p) => p.id === parseInt(selectedProduct));
        if (!selectedProductDetails) return alert("Invalid product selection!");

        if (!repairId || typeof repairId !== "number") {
            console.error("Error: repairId is invalid", repairId);
            return alert("Error: Repair ID is invalid!");
        }

        try {
            setIsLoading(true);
            await addRepairParts(repairId, [
                {
                    productId: selectedProductDetails.id,
                    quantity,
                    price: selectedProductDetails.price,
                },
            ]);
            setIsLoading(false);
            alert("Parts updated successfully!"); // ✅ Show success message instead of closing the modal
            onPartsUpdated(); // ✅ Refresh repair data
        } catch (error) {
            setIsLoading(false);
            alert("Error updating parts");
            console.error(error);
        }
    };



    const selectedProductDetails = selectedProduct
        ? products.find(p => p.id === parseInt(selectedProduct))
        : null;

    return (
        <div className={styles["repair-modal-overlay"]}>
            <div className={styles["update-parts-modal"]}>
                <div className={styles["update-parts-header"]}>
                    <h3><AiOutlineTool className={styles["header-icon"]} /> Update Repair Parts</h3>
                    <button onClick={onClose} className={styles["modal-close-btn"]}>
                        <AiOutlineClose />
                    </button>
                </div>
                <div className={styles["update-parts-content"]}>
                    <div className={styles["form-group"]}>
                        <label htmlFor="product-select">Select Product</label>
                        <select
                            id="product-select"
                            value={selectedProduct}
                            onChange={(e) => setSelectedProduct(e.target.value)}
                            className={styles["form-control"]}
                            disabled={isLoading}
                        >
                            <option value="">-- Select a Product --</option>
                            {products.map((product) => (
                                <option key={product.id} value={product.id}>
                                    {product.name} - Rs.{product.price}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className={styles["form-group"]}>
                        <label htmlFor="quantity-input">Quantity</label>
                        <input
                            id="quantity-input"
                            type="number"
                            min="1"
                            placeholder="Enter quantity"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                            className={styles["form-control"]}
                            disabled={isLoading}
                        />
                    </div>

                    {selectedProductDetails && (
                        <div className={styles["product-summary"]}>
                            <h4>Summary</h4>
                            <div className={styles["summary-row"]}>
                                <span>Product:</span>
                                <span>{selectedProductDetails.name}</span>
                            </div>
                            <div className={styles["summary-row"]}>
                                <span>Unit Price:</span>
                                <span>Rs.{selectedProductDetails.price}</span>
                            </div>
                            <div className={styles["summary-row"]}>
                                <span>Quantity:</span>
                                <span>{quantity}</span>
                            </div>
                            <div className={styles["summary-row summary-total"]}>
                                <span>Total:</span>
                                <span>Rs.{(selectedProductDetails.price * quantity).toFixed(2)}</span>
                            </div>
                        </div>
                    )}
                </div>
                <div className={styles["update-parts-footer"]}>
                    <button
                        onClick={onClose}
                        className={styles["cancel-button"]}
                        disabled={isLoading}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleUpdateParts}
                        className={styles["update-button"]}
                        disabled={!selectedProduct || isLoading}
                    >
                        {isLoading ? "Processing..." : (
                            <>
                                <AiOutlinePlus /> Update Parts
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpdatePartsModal;